<template>
  <div class="payment-module-credit-cards-container">
    <div class="change-payment-method-link" @click="$emit('update:step', 3)">
      + Add new credit card
    </div>

    <credit-card-item
      v-for="card in availableCreditCards"
      :key="card.token"
      :data="card"
      hide-default-icon
      :isSelected="card.token === selectedCardToken"
      :class="{ 'credit-card-item--is-selected': card.token === selectedCardToken }"
      @click.native="selectedCardToken = card.token"
      @deletePaymentMethod="onDeleteCreditCard(card.token)"
    />

    <cg-button :disabled="!selectedCardData" @click="onContinue">Continue</cg-button>
  </div>
</template>

<script>
import PaymentType from '../utils/PaymentType'

import CreditCardItem from '@/components/payment/CreditCardItem.vue'
import { CgButton } from '@corporategiftcom/design-system'

export default {
  name: 'PayWithCreditCard',
  components: {
    CreditCardItem,
    CgButton,
  },
  props: {
    paymentData: {
      type: Object,
      required: false,
      default: null,
    },
    availableCreditCards: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selectedCardToken: null,
  }),
  computed: {
    defaultCreditCard () {
      const { availableCreditCards } = this
      return availableCreditCards.find(({ isDefault }) => isDefault) ?? null
    },
    selectedCardData () {
      const { selectedCardToken, availableCreditCards } = this

      if (!selectedCardToken) { return null }
      return availableCreditCards.find((cardData) => cardData.token === selectedCardToken)
    },
  },
  created () {
    const { paymentData, defaultCreditCard } = this

    if (paymentData && paymentData?.token) {
      this.selectedCardToken = paymentData?.token
    } else if (defaultCreditCard) {
      this.selectedCardToken = defaultCreditCard?.token ?? null
    }
  },
  methods: {
    onContinue () {
      const { selectedCardData } = this

      if (selectedCardData) {
        this.$emit('onCardSelect', PaymentType.CC, selectedCardData);
      }
    },
    onDeleteCreditCard (cardToken) {
      this.$emit('onDeleteCard', cardToken)
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-module-credit-cards-container {
  display: flex;
  flex-direction: column;
  gap: 20px;

  & > .credit-card-item {
    cursor: pointer;
    border: 1px solid transparent;
    transition: background-color ease-in-out 0.26s;

    &:not(&--is-selected):hover {
      background-color: #F4F4F4;
    }

    &--is-selected {
      border-color: #D3D2D2;
      cursor: default;
      background-color: #fff;
    }
  }

  & .change-payment-method-link {
    font-family: 'Lato-Regular', sans-serif;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
    color: #42B77A;
  }

  & .cg-button {
    margin-top: 20px;
    border-radius: 100px;
  }
}
</style>
